export const hexToRGBA = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16),
        a = alpha || (parseInt(hex.slice(7, 9), 16) / 255);

    return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
}